import { useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { exchangeSession } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    exchangeSession(sessionId)
      .then(res => {
        setUser(res.data.user);
        navigate('/dashboard', { replace: true, state: { user: res.data.user } });
      })
      .catch(() => {
        navigate('/login', { replace: true });
      });
  }, [navigate, location, setUser]);

  return (
    <div className="min-h-screen bg-[#EFF2F7] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 animate-fade-in">
        <div className="w-14 h-14 rounded-2xl bg-[#3A86FF] flex items-center justify-center animate-pulse">
          <span className="text-white font-bold text-lg">FT</span>
        </div>
        <p className="text-sm text-[#64748B]">Connexion en cours...</p>
      </div>
    </div>
  );
}
